module.exports = __webpack_public_path__ + "static/media/12.1a8c7d07.jpg";